import React, { Component } from 'react';
import ajax from 'superagent';
import { Field } from 'redux-form';
import SelectField from './SelectField';

class AttributeOptions extends Component {

    constructor(props) {
        super(props);
        this.state = { attribute_options: this.props.attributeOptions };
        this.renderHandledSelectField = this.renderHandledSelectField.bind(this);
    }

    componentWillMount() {
        const ROOT_URL = process.env.API_URL;
        ajax.get(ROOT_URL + '/attribute_options/' + this.props.attributeName)
            .end((error, response) => {
                if (!error && response) {
                    this.setState({ attribute_options: response.body.attribute_options });
                } else {
                    console.log('There was an error fetching from API', error);
                }
            }
        );

    }

    renderHandledSelectField(props) {
        let customOnChange=props.input.onChange
        if(this.props.onChange){
            customOnChange = (event) => {
                this.props.onChange(event.target.value);
                props.input.onChange(event);
            }
        }
        let field_props = Object.assign({}, props, {input: {...props.input, onChange: customOnChange}})
        return (<SelectField {...field_props} />);
    }


    render() {
        return (
            <Field
                className="form-control"
                name={this.props.name}
                component={this.renderHandledSelectField}
                options={this.props.attributeOptions}
                defaultValue={this.props.defaultValue}
                label={this.props.label}
                type="select"
            />
        );
    }
}

export default AttributeOptions;


/** WEBPACK FOOTER **
 ** ./src/components/AttributeOptions.js
 **/